<template>
  <button
    class="btn-square bg-transparent border border-solid border-transparent transition-transform group"
    :class="{ 'rotate-90': expanded }"
    @click="onToggleExpanded"
  >
    <em
      class="custom-icons bg-icon-default group-hover:bg-icon-hover"
      :style="getCustomIconStyle(iconPath('chevron-right'))"
    />
  </button>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';

export default {
  mixins: [customIconsMixin],
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update'],
  methods: {
    onToggleExpanded() {
      this.$emit('update', !this.expanded);
    },
  },
};
</script>
